/* Rynix — shared JS */
(() => {
  // Mobile PLP filter drawer
  const toggleBtns = document.querySelectorAll('[data-rx-plp-toggle]');
  toggleBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const aside = document.querySelector('[data-rx-plp-aside]');
      if (!aside) return;
      aside.classList.toggle('is-open');
      document.body.classList.toggle('rx-no-scroll', aside.classList.contains('is-open'));
    });
  });

  // Mobile menu drawer (header hamburger)
  const menuDrawer = document.querySelector('[data-rx-drawer]');
  const setMenuDrawer = (open) => {
    if (!menuDrawer) return;
    menuDrawer.classList.toggle('is-open', open);
    menuDrawer.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('rx-no-scroll', open);
  };
  document.querySelectorAll('[data-rx-drawer-open]').forEach(btn => {
    btn.addEventListener('click', (e) => { e.preventDefault(); setMenuDrawer(true); });
  });
  document.querySelectorAll('[data-rx-drawer-close]').forEach(btn => {
    btn.addEventListener('click', (e) => { e.preventDefault(); setMenuDrawer(false); });
  });
  // Close drawer when a link inside it is clicked (so nav feels native)
  if (menuDrawer) {
    menuDrawer.querySelectorAll('a[href]').forEach(a => {
      a.addEventListener('click', () => setMenuDrawer(false));
    });
  }

  // Close any open drawer on Escape
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.is-open').forEach(el => el.classList.remove('is-open'));
    document.body.classList.remove('rx-no-scroll');
    if (menuDrawer) menuDrawer.setAttribute('aria-hidden', 'true');
  });

  // ---------- Quick-add helpers ----------
  const formatMoney = (cents) => {
    const n = (cents || 0) / 100;
    return '$' + n.toFixed(2);
  };
  const refreshCartCount = async () => {
    try {
      const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
      if (r.ok) {
        const c = await r.json();
        document.querySelectorAll('[data-rx-cart-count]').forEach(el => {
          el.textContent = c.item_count;
          if (c.item_count === 0) el.setAttribute('hidden',''); else el.removeAttribute('hidden');
        });
      }
    } catch {}
  };
  const openCartDrawer = () => {
    // Use the cart-drawer's own API so it fetches /cart.js and renders properly.
    // The cart drawer exposes window.rxCartDrawer.open() in rynix-header.liquid
    // (and handles body-overflow lock + close logic itself).
    if (window.rxCartDrawer && typeof window.rxCartDrawer.open === 'function') {
      window.rxCartDrawer.open();
      return;
    }
    // Fallback (shouldn't normally hit): trigger via the standard click target
    // so the cart-drawer's delegated click handler runs openDrawer().
    const trigger = document.querySelector('[data-rx-cart-open]');
    if (trigger) trigger.click();
  };

  // ---------- Quick-add modal (for multi-variant products on PLP) ----------
  const modal = document.getElementById('rxQuickadd');
  const setModal = (open) => {
    if (!modal) return;
    modal.classList.toggle('is-open', open);
    modal.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('rx-no-scroll', open);
  };
  modal && modal.querySelectorAll('[data-rx-quickadd-close]').forEach(b => {
    b.addEventListener('click', () => setModal(false));
  });

  async function fetchProductJson(handleOrUrl) {
    // Accept full url like /products/foo or just handle
    const url = new URL(handleOrUrl.includes('/products/') ? handleOrUrl : '/products/' + handleOrUrl, window.location.origin);
    if (url.origin !== window.location.origin) throw new Error('Unexpected product origin');
    url.pathname = url.pathname.replace(/\/$/, '').replace(/\.js$/, '') + '.js';
    url.search = '';
    url.hash = '';
    const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('product fetch ' + res.status);
    const product = await res.json();
    product.options = (product.options || []).map(option => typeof option === 'string' ? option : option.name);
    return product;
  }

  function findMatchingVariant(product, selectedOpts) {
    return product.variants.find(v => {
      for (let i = 0; i < selectedOpts.length; i++) {
        if (selectedOpts[i] && v.options[i] !== selectedOpts[i]) return false;
      }
      return selectedOpts.every(Boolean) ? true : false;
    });
  }

  function renderModal(product) {
    const body = modal.querySelector('[data-rx-quickadd-body]');
    const featured = (product.featured_image || (product.images && product.images[0]) || '');
    const imgUrl = featured ? featured.replace(/^https?:/, '').replace(/(\.(jpg|jpeg|png|webp))/, '_400x$1') : '';
    const firstVar = product.variants.find(v => v.available) || product.variants[0];
    const html = `
      <div class="rx-quickadd__head">
        <div class="rx-quickadd__media">${imgUrl ? `<img src="${imgUrl}" alt="">` : ''}</div>
        <div class="rx-quickadd__meta">
          <h3 class="rx-quickadd__title" id="rxQuickaddTitle">${product.title}</h3>
          <div class="rx-quickadd__price" data-rx-qa-price>${formatMoney(firstVar.price)}</div>
        </div>
      </div>
      <div class="rx-quickadd__opts" data-rx-qa-opts>
        ${product.options.map((optName, i) => `
          <div class="rx-quickadd__opt">
            <div class="rx-quickadd__opt-label">${optName}</div>
            <div class="rx-quickadd__opt-values" data-rx-qa-opt="${i}">
              ${[...new Set(product.variants.map(v => v.options[i]))].map(val => `
                <button type="button" class="rx-quickadd__opt-val" data-rx-qa-val="${val.replace(/"/g,'&quot;')}">${val}</button>
              `).join('')}
            </div>
          </div>
        `).join('')}
      </div>
      <p class="rx-shipping-estimate" data-rx-qa-shipping aria-live="polite">Select a size to see its delivery estimate.</p>
      <button type="button" class="rx-btn rx-btn--primary rx-quickadd__cta" data-rx-qa-cta>
        <span data-rx-qa-cta-label>Select options to add</span>
      </button>
      <a href="${product.url}" class="rx-quickadd__view">View full product details →</a>
    `;
    body.innerHTML = html;

    // State of currently selected options
    const selectedOpts = new Array(product.options.length).fill(null);

    // Initialize: if a variant is fully determined by single-value options, preselect them
    product.options.forEach((_, i) => {
      const uniq = [...new Set(product.variants.map(v => v.options[i]))];
      if (uniq.length === 1) selectedOpts[i] = uniq[0];
    });

    function updateUI() {
      // Highlight selected option buttons
      body.querySelectorAll('[data-rx-qa-opt]').forEach(group => {
        const i = +group.dataset.rxQaOpt;
        group.querySelectorAll('[data-rx-qa-val]').forEach(btn => {
          btn.classList.toggle('is-selected', btn.dataset.rxQaVal === selectedOpts[i]);
          // Disable button if no available variant has this combination
          const trialOpts = selectedOpts.slice();
          trialOpts[i] = btn.dataset.rxQaVal;
          const candidate = product.variants.find(v => {
            return trialOpts.every((o, j) => o === null || v.options[j] === o);
          });
          btn.classList.toggle('is-unavailable', !candidate || !candidate.available);
        });
      });
      // Compute current matching variant
      const v = findMatchingVariant(product, selectedOpts);
      body.querySelector('[data-rx-qa-shipping]').textContent = v ? window.rxShipping.label(v.id) : 'Select a size to see its delivery estimate.';
      const priceEl = body.querySelector('[data-rx-qa-price]');
      const cta = body.querySelector('[data-rx-qa-cta]');
      const ctaLabel = body.querySelector('[data-rx-qa-cta-label]');
      if (v) {
        priceEl.textContent = formatMoney(v.price);
        if (v.available) {
          ctaLabel.textContent = 'Add to cart — ' + formatMoney(v.price);
          cta.disabled = false;
          cta.dataset.rxQaVariantId = v.id;
        } else {
          ctaLabel.textContent = 'Sold out';
          cta.disabled = true;
        }
      } else {
        const remain = selectedOpts.filter(o => !o).length;
        ctaLabel.textContent = remain ? `Select ${remain} option${remain>1?'s':''} to add` : 'Unavailable';
        cta.disabled = true;
      }
    }

    // Wire up option clicks
    body.querySelectorAll('[data-rx-qa-val]').forEach(btn => {
      btn.addEventListener('click', () => {
        const group = btn.closest('[data-rx-qa-opt]');
        const i = +group.dataset.rxQaOpt;
        selectedOpts[i] = btn.dataset.rxQaVal;
        updateUI();
      });
    });

    // Wire up Add to cart
    const cta = body.querySelector('[data-rx-qa-cta]');
    cta.addEventListener('click', async () => {
      const vid = cta.dataset.rxQaVariantId;
      if (!vid || cta.disabled || window.rxCommerce.pending()) return;
      if (window.rxCommerce.needsCartReview()) { window.location.href = '/cart'; return; }
      const origLabel = body.querySelector('[data-rx-qa-cta-label]').textContent;
      cta.disabled = true;
      body.querySelector('[data-rx-qa-cta-label]').textContent = 'Adding…';
      try {
        const payload = new FormData();
        payload.set('id', vid); payload.set('quantity', '1');
        Object.entries(window.rxShipping.properties(vid)).forEach(([key, value]) => payload.set('properties[' + key + ']', value));
        const result = await window.rxCommerce.add(payload);
        if (!result.ok) throw result;
        await refreshCartCount();
        body.querySelector('[data-rx-qa-cta-label]').textContent = 'Added ✓';
        setTimeout(() => {
          setModal(false);
          openCartDrawer();
        }, 600);
      } catch (err) {
        console.error('[quickadd-modal]', err);
        window.rxCommerce.showError(body, err);
        updateUI();
        if (err.uncertain) { cta.disabled = false; body.querySelector('[data-rx-qa-cta-label]').textContent = 'View cart'; }
      }
    });

    updateUI();
  }

  async function openQuickaddModal(productUrl) {
    if (!modal) return;
    const body = modal.querySelector('[data-rx-quickadd-body]');
    body.innerHTML = '<div class="rx-quickadd__loading">Loading…</div>';
    setModal(true);
    try {
      const product = await fetchProductJson(productUrl);
      renderModal(product);
    } catch (err) {
      console.error('[quickadd-modal] load failed, falling back to PDP', err);
      window.location.href = productUrl;
    }
  }

  // ---------- Quick-add click handler ----------
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-rx-quickadd]');
    if (!btn) return;
    e.preventDefault();
    const isMulti = btn.dataset.rxMulti === 'true';
    // Multi-variant → open quick-add modal (no nav)
    if (isMulti) {
      const url = btn.dataset.rxUrl;
      if (url) openQuickaddModal(url);
      return;
    }
    // Single variant → direct add
    const vid = btn.dataset.rxVid;
    if (!vid || btn.disabled || window.rxCommerce.pending()) return;
    if (window.rxCommerce.needsCartReview()) { window.location.href = '/cart'; return; }
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      const payload = new FormData();
        payload.set('id', vid); payload.set('quantity', '1');
        Object.entries(window.rxShipping.properties(vid)).forEach(([key, value]) => payload.set('properties[' + key + ']', value));
        const result = await window.rxCommerce.add(payload);
        if (!result.ok) throw result;
      await refreshCartCount();
      btn.classList.add('is-added');
      btn.textContent = 'Added ✓';
      openCartDrawer();
      setTimeout(() => {
        btn.classList.remove('is-added');
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1800);
    } catch (err) {
      console.error('[quickadd]', err);
      window.rxCommerce.showError(btn.parentElement, err);
      btn.textContent = err.uncertain ? 'View cart' : originalText;
      btn.disabled = false;
    }
  });

  // Star badge → smooth-scroll to the rendered Judge.me review widget
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-rx-scroll-reviews]');
    if (!link) return;
    e.preventDefault();
    const widgets = [...document.querySelectorAll('.jdgm-review-widget')];
    const target = widgets.find(w => w.offsetHeight > 10) || widgets[0];
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // ---------- Recon detection: tag sessions that look like competitive research ----------
  // Sends custom tags / events to Microsoft Clarity (if loaded) so suspicious sessions
  // can be filtered in the Clarity dashboard.
  function rxTagClarity(name, value) {
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set', name, value == null ? '1' : String(value));
        window.clarity('event', name);
      }
    } catch (e) {}
  }

  // A. DevTools open detection — by window size delta (works on Chromium/Firefox/Safari)
  let _devtoolsTagged = false;
  function checkDevTools() {
    if (_devtoolsTagged) return;
    const threshold = 160;
    const widthDiff = Math.abs(window.outerWidth - window.innerWidth);
    const heightDiff = Math.abs(window.outerHeight - window.innerHeight);
    const isDocked = widthDiff > threshold || heightDiff > threshold;
    if (isDocked) {
      _devtoolsTagged = true;
      rxTagClarity('rx_devtools_open', 'docked');
    }
  }
  // Sample at intervals (cheap)
  setInterval(checkDevTools, 4000);
  checkDevTools();

  // Alternative: console-based detection (works when DevTools undocked)
  let _consoleTagged = false;
  const _baitObj = /./;
  _baitObj.toString = function () {
    if (!_consoleTagged) {
      _consoleTagged = true;
      rxTagClarity('rx_devtools_open', 'console');
    }
    return '';
  };
  setInterval(() => { console.debug(_baitObj); }, 7000);

  // B. Rapid clicks on coupon / discount UI (recon pattern: click everything to inspect handlers)
  let _claimClicks = 0;
  let _claimWinStart = 0;
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-rx-copy], .rx-pdp__coupon-copy, [data-rx-discount-toggle], [data-rx-discount-apply], [data-rx-discount-remove]');
    if (!t) return;
    const now = Date.now();
    if (now - _claimWinStart > 12000) {
      _claimClicks = 0;
      _claimWinStart = now;
    }
    _claimClicks++;
    if (_claimClicks === 5) {
      rxTagClarity('rx_rapid_coupon_clicks', String(_claimClicks));
    }
  });

  // C. Long single-PDP dwell with no add-to-cart (research signature)
  if (/\/products\//.test(location.pathname)) {
    let _pdpStart = Date.now();
    let _addedToCart = false;
    document.addEventListener('click', (e) => {
      if (e.target.closest('#rxAddToCartBtn, [data-rx-quickadd], form[action*="cart/add"] [type="submit"]')) {
        _addedToCart = true;
      }
    });
    // Tag at 5 min on a PDP without ever adding to cart
    setTimeout(() => {
      if (!_addedToCart) rxTagClarity('rx_long_pdp_dwell_no_atc', '5min');
    }, 5 * 60 * 1000);
  }

  // D. Right-click / view-source attempt count
  let _rclickCount = 0;
  document.addEventListener('contextmenu', () => {
    _rclickCount++;
    if (_rclickCount === 3) rxTagClarity('rx_rapid_rightclick', '3');
  });
  // Common DevTools hotkeys
  document.addEventListener('keydown', (e) => {
    const k = e.key;
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && (k === 'I' || k === 'i' || k === 'J' || k === 'j' || k === 'C' || k === 'c')) {
      rxTagClarity('rx_devtools_hotkey', k);
    } else if (k === 'F12') {
      rxTagClarity('rx_devtools_hotkey', 'F12');
    } else if ((e.ctrlKey || e.metaKey) && (k === 'u' || k === 'U')) {
      rxTagClarity('rx_view_source_hotkey', 'Ctrl+U');
    }
  });

})();

// 0831 audit: 跨断点清理筛选浮层状态
(() => {
  const rxPlpMq = window.matchMedia('(min-width: 901px)');
  const reset = () => {
    const aside = document.querySelector('[data-rx-plp-aside]');
    if (aside) aside.classList.remove('is-open');
    document.body.classList.remove('rx-no-scroll');
  };
  if (rxPlpMq.addEventListener) rxPlpMq.addEventListener('change', e => { if (e.matches) reset(); });
})();
